import React, { useState, useEffect } from "react";
import { Table, Badge, Card } from 'react-bootstrap';
// Certifique-se de exportar geo_busca_alunos e Pega_QTD_alunos_Seg no seu arquivo de api
import { geo_busca_alunos, Pega_QTD_alunos_Seg } from "../../services/api";
import SantaMonicaLogo from '../../img/santa_monica_logo_rgb.png';

const Geo_alunos_range = ({ unidade, range, onDataProcessed }) => {
    // Estados
    const [dadosAlunos, setDadosAlunos] = useState([]);
    const [dadosProprios, setDadosProprios] = useState([]); // Novo estado para os dados de 25/26
    const [sortConfig, setSortConfig] = useState({ key: 'nome', direction: 'asc' });

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio'];

    // Função auxiliar para mapear a dependência
    const getDependenciaNome = (tipo) => {
        switch (tipo) {
            case 1: return "Federal";
            case 2: return "Estadual";
            case 3: return "Municipal";
            case 4: return "Particular";
            default: return "Não Informado";
        }
    };

    const fetchData = async () => {
        try {
            // Busca dos dados das escolas concorrentes no range
            const responseAlunos = await geo_busca_alunos(unidade, range);
            const listaSaneada = Array.isArray(responseAlunos) ? responseAlunos : (responseAlunos?.data || []);

            // Formatando dados e calculando o total de alunos por escola
            const dadosFormatados = listaSaneada.map(escola => ({
                nome: escola.no_entidade,
                dependencia: getDependenciaNome(escola.tp_dependencia),
                infantil: parseInt(escola.qt_mat_inf || 0),
                fund_ai: parseInt(escola.qt_mat_fund_ai || 0),
                fund_af: parseInt(escola.qt_mat_fund_af || 0),
                medio: parseInt(escola.qt_mat_med || 0),
                total_escola: (
                    parseInt(escola.qt_mat_inf || 0) +
                    parseInt(escola.qt_mat_fund_ai || 0) +
                    parseInt(escola.qt_mat_fund_af || 0) +
                    parseInt(escola.qt_mat_med || 0)
                )
            }));

            setDadosAlunos(dadosFormatados);

            // COMUNICAÇÃO COM O MESTRE: Calcula o total de todos os alunos e envia
            if (onDataProcessed) {
                const grandTotalAlunos = dadosFormatados.reduce((acc, curr) => acc + curr.total_escola, 0);
                onDataProcessed(grandTotalAlunos);
            }

        } catch (error) {
            console.error("Erro ao buscar dados de alunos no range:", error);
            setDadosAlunos([]);

            // Zera o contador do mestre em caso de erro
            if (onDataProcessed) {
                onDataProcessed(0);
            }
        }
    };

    // Nova função para buscar os dados próprios da unidade (2025 vs 2026)
    const fetchDadosProprios = async () => {
        try {
            // Chama a API sem parâmetros
            const responseProprios = await Pega_QTD_alunos_Seg();

            // Extrai o array de dados dependendo de como a API retorna
            const listaTodos = Array.isArray(responseProprios) ? responseProprios : (responseProprios?.data || []);

            // Encontra apenas o objeto correspondente à unidade selecionada no painel mestre
            // Forçamos para string caso a prop venha como número, para garantir a igualdade (ex: "01" === "01")
            const dadosUnidade = listaTodos.find(item => item.unidade === String(unidade));

            setDadosProprios(dadosUnidade || null);
        } catch (error) {
            console.error("Erro ao buscar dados próprios da unidade:", error);
            setDadosProprios(null);
        }
    };

    useEffect(() => {
        if (unidade && range) {
            fetchData();
            fetchDadosProprios(); // Aciona a busca do nosso painel quando unidade/range mudam
        }
    }, [unidade, range]);

    // Função de Ordenação
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...dadosAlunos].sort((a, b) => {
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];

        // Tratamento para strings (nome, dependencia) x números (matrículas)
        if (typeof valA === 'string' && typeof valB === 'string') {
            valA = valA.toUpperCase();
            valB = valB.toUpperCase();
        }

        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    // Helper para ícones de ordenação
    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return " ↕";
        return sortConfig.direction === 'asc' ? " 🔼" : " 🔽";
    };

    return (
        <div>
            {/* NOVO: PAINEL DE DADOS PRÓPRIOS (2025 vs 2026) */}
            {dadosProprios && (
                <Card className="mb-4 shadow-sm border-primary">
                    <Card.Header className="bg-primary text-white py-2 d-flex align-items-center">
                        <h6 className="m-0 fw-bold">
                            <img src={SantaMonicaLogo} alt="Santa Mônica" style={{ width: '5%', height: 'auto', marginRight: '6px', verticalAlign: 'middle' }} />
                            Desempenho da Unidade: {unidades[parseInt(unidade)]} (Evolução 25/26)
                        </h6>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Table responsive size="sm" className="m-0 text-center align-middle">
                            <thead className="table-light">
                                <tr style={{ fontSize: '12px' }}>
                                    <th className="text-start ps-3">ANO LETIVO</th>
                                    <th>INFANTIL</th>
                                    <th>FUND. INICIAIS (F1)</th>
                                    <th>FUND. FINAIS (F2)</th>
                                    <th>MÉDIO</th>
                                    <th className="bg-info text-dark">TOTAL MATRÍCULAS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-start ps-3 fw-bold text-secondary">2025</td>
                                    <td>{dadosProprios.infantil_25}</td>
                                    <td>{dadosProprios.fund1_25}</td>
                                    <td>{dadosProprios.fund2_25}</td>
                                    <td>{dadosProprios.medio_25}</td>
                                    <td className="fw-bold table-info text-dark">{dadosProprios.matriculas_25}</td>
                                </tr>
                                <tr>
                                    <td className="text-start ps-3 fw-bold text-primary">2026</td>
                                    <td className="fw-bold">{dadosProprios.infantil_26}</td>
                                    <td className="fw-bold">{dadosProprios.fund1_26}</td>
                                    <td className="fw-bold">{dadosProprios.fund2_26}</td>
                                    <td className="fw-bold">{dadosProprios.medio_26}</td>
                                    <td className="fw-bold table-info text-primary fs-6">{dadosProprios.matriculas_26}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            )}

            {/* TABELA ORIGINAL DE CONCORRENTES NO RANGE */}
            <div className="table-responsive shadow-sm border rounded" style={{ maxHeight: '60vh' }}>
                <Table striped bordered hover size="sm" className="align-middle bg-white m-0">
                    <thead className="table-dark text-center sticky-top">
                        <tr style={{ fontSize: '11px', cursor: 'pointer' }}>
                            <th onClick={() => requestSort('nome')} className="align-middle text-start ps-3" style={{ minWidth: '220px' }}>
                                ESCOLA {getSortIcon('nome')}
                            </th>
                            <th onClick={() => requestSort('dependencia')} className="align-middle">
                                DEPENDÊNCIA {getSortIcon('dependencia')}
                            </th>
                            <th onClick={() => requestSort('infantil')} className="align-middle">
                                INFANTIL {getSortIcon('infantil')}
                            </th>
                            <th onClick={() => requestSort('fund_ai')} className="align-middle">
                                FUNDAMENTAL (INICIAIS) {getSortIcon('fund_ai')}
                            </th>
                            <th onClick={() => requestSort('fund_af')} className="align-middle">
                                FUNDAMENTAL (FINAIS) {getSortIcon('fund_af')}
                            </th>
                            <th onClick={() => requestSort('medio')} className="align-middle">
                                MÉDIO {getSortIcon('medio')}
                            </th>
                            <th onClick={() => requestSort('total_escola')} className="align-middle bg-info text-dark">
                                TOTAL DA ESCOLA {getSortIcon('total_escola')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.length > 0 ? (
                            sortedData.map((item, index) => (
                                <tr key={index} className="text-center">
                                    <td className="text-start fw-bold small ps-3 text-primary">
                                        {item.nome?.toUpperCase().includes("SANTA MONICA REDE DE ENSINO") ? (
                                            <>
                                                <img src={SantaMonicaLogo} alt="Santa Mônica" style={{ width: '10%', height: 'auto', marginRight: '6px', verticalAlign: 'middle' }} />
                                                <span style={{ textDecoration: 'underline' }}>{item.nome}</span>
                                            </>
                                        ) : (
                                            item.nome
                                        )}
                                    </td>
                                    <td>
                                        <Badge bg={item.dependencia === 'Particular' ? 'warning' : 'info'} text={item.dependencia === 'Particular' ? 'dark' : 'light'}>
                                            {item.dependencia}
                                        </Badge>
                                    </td>
                                    <td className="small">{item.infantil}</td>
                                    <td className="small">{item.fund_ai}</td>
                                    <td className="small">{item.fund_af}</td>
                                    <td className="small">{item.medio}</td>
                                    <td><strong className="text-info">{item.total_escola}</strong></td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center py-4 text-muted">
                                    Nenhum dado de alunos retornado para os parâmetros informados.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}

export default Geo_alunos_range;